import { CellCoordsObj, CellData } from '../../../../../../common/table/TableTypes';
import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';
import { getSharedCellTypeFormatOptions } from '../../dataUtils/cell/tableCellTypeModelUtils';
import { updateCellType } from '../../dataUtils/cell/tableCellTypeUpdateUtils';
import { getNormalisedComputedCellValueFromHot } from './hotTableCellRenderValueUtils';
import { getHotTableCellData } from '../meta/hotTableCellMetaUtils';
import type { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Returns the shared formatting state for the current HoT selection.
 */
export const getSharedCellTypeFormatOptionsFromHot = (
    hotInstance: MNHotInstance | null | undefined,
    allSelectedCells: Array<CellCoordsObj>,
) => {
    if (!hotInstance || !allSelectedCells || allSelectedCells.length === 0) return;

    const selectedCellsTypes = allSelectedCells.map(
        ({ row, col }) => getHotTableCellData(hotInstance, { row, col })?.type,
    );

    return getSharedCellTypeFormatOptions(selectedCellsTypes);
};

/**
 * Updates a cell type using live HoT data needed to validate formula-backed values.
 */
export const updateHotCellType = (
    hot: MNHotInstance | null | undefined,
    prevCellData: CellData,
    cellTypeName: CellTypeNames,
    currencyPreference: string,
    elementId: string,
    row: number | undefined,
    col: number | undefined,
): CellData => {
    if (!hot) return prevCellData;

    const { locale } = hot.milanoteProps;
    const normalisedComputedCellValue = getNormalisedComputedCellValueFromHot(elementId, row, col, hot);

    return updateCellType(prevCellData, cellTypeName, currencyPreference, locale, normalisedComputedCellValue);
};
